import { create } from 'zustand';

/** Live-connection state per realtime namespace (data-model.md B1; WEB-010 offline notice). */
export type ConnectionStatus = 'idle' | 'connecting' | 'online' | 'offline';
export type Namespace = 'messaging' | 'calls';

interface ConnectionState {
  messaging: ConnectionStatus;
  calls: ConnectionStatus;
  lastOnlineAt: number | null;
  setStatus: (namespace: Namespace, status: ConnectionStatus) => void;
  reset: () => void;
}

export const useConnectionStore = create<ConnectionState>()((set) => ({
  messaging: 'idle',
  calls: 'idle',
  lastOnlineAt: null,
  setStatus: (namespace, status) =>
    set(
      status === 'online'
        ? { [namespace]: status, lastOnlineAt: Date.now() }
        : { [namespace]: status },
    ),
  reset: () => set({ messaging: 'idle', calls: 'idle' }),
}));

/** Whether to show the offline notice: live updates were working and have dropped. */
export const selectIsOffline = (state: ConnectionState) =>
  state.messaging === 'offline' || state.calls === 'offline';
